// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__ce6-z","name":"Footer_name__ghzy+","links":"Footer_links__9s+kk"};